// Bundlers like vite and nextjs (webpack) expose asset imports differently,
// either as `string` or `{ src: string }`. getSrc returns as `string` to
// allow components use be used by either bundler
export function getSrc(asset: string | { src: string }): string {
  return typeof asset === 'string' ? asset : asset.src;
}
